import { PIECES } from '../consts/pieces.js';

function ATTACK_PIECE({
    blindKingsGame: {
        turnNumber,
        turnIndex,
        board,
        graveyard,
        following,
    },
    gamePiece,
    gamePiece: {
        id,
        value,
        teamIndex,
        location: {
            x: oldX,
            y: oldY,
        },
    },
    direction,
}) {

    const pieceBeingAttacked = gamePiece.getPieceToAttackByDirection(direction);
    const {
        id: pieceBeingAttackedId,
        value: pieceBeingAttackedValue,
        teamIndex: pieceBeingAttackedTeamIndex,
        location: {
            x: newX,
            y: newY,
        },
    } = pieceBeingAttacked;

    const newBoard = board.map((row, boardY) => row.map((boardPiece, boardX) => {
        if ((boardX === oldX) && (boardY === oldY)) return {
            id: pieceBeingAttackedId,
            ...PIECES.Empty
        };
        if ((boardX === newX) && (boardY === newY)) return {
            id,
            value,
            teamIndex,
        };
        return boardPiece;
    }));

    const newGraveyard = [
        ...graveyard,
        {
            value: pieceBeingAttackedValue,
            teamIndex: pieceBeingAttackedTeamIndex,
        }
    ];

    const newFollowing = {
        ...following,
        [turnIndex]: {},
    };

    return {
        board: newBoard,
        graveyard: newGraveyard,
        turnNumber: turnNumber + 1,
        turnsWithoutAction: 0,
        following: newFollowing,
    };
}

export default ATTACK_PIECE;